import { render } from "./AccessEditRole.vue?vue&type=template&id=89585262"
import script from "./AccessEditRole.vue?vue&type=script&lang=js"
export * from "./AccessEditRole.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__